import React from 'react'
import Loading from "../components/common/Loading";
import Head from "next/head";
import DebitNote from '@/components/DebitNote';

const debitNote = () => {
    return (
        <>
            <Head>
                <title>Debit Note Format Free Download: Excel, Word, Docs, and PDF</title>
                <link rel="canonical" href="https://queuebuster.co/debit-note" />
                <link rel="alternate" href="https://queuebuster.co/debit-note" hrefLang="en" />
                <meta name="description" content="Download free debit note templates in Excel, Word, Google Docs, and PDF formats. QueueBuster POS provides expert tips for creating professional debit notes." />
                <meta property="og:title" content="Debit Note Format Free Download in Excel, Word, Docs, and PDF | QueueBuster" />
                <meta property="og:description" content="Access free downloadable debit note templates in Excel, Word, Google Docs, and PDF formats from QueueBuster. Learn best practices for creating professional and accurate debit notes. This content emphasizes the availability and ease of access to debit note templates in multiple formats, appealing to a wide range of users." />
                <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/debit-note.jpg" />
                <meta property="og:url" content="https://queuebuster.co/debit-note" />
            </Head>
            <DebitNote />
        </>
    )
}

export default debitNote